"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Grid_1 = __importDefault(require("@mui/material/Grid"));
const Main_1 = __importDefault(require("@/components/Main"));
const ProductChangeLog_1 = __importDefault(require("./components/ProductChangeLog"));
const ProductsTable_1 = __importDefault(require("./components/ProductsTable"));
function ProductsView() {
    return (react_1.default.createElement(Main_1.default, null,
        react_1.default.createElement(Grid_1.default, { container: true, spacing: 4 },
            react_1.default.createElement(Grid_1.default, { xs: 8, item: true },
                react_1.default.createElement(ProductsTable_1.default, null)),
            react_1.default.createElement(Grid_1.default, { xs: 4, item: true, sx: { marginTop: "70px" } },
                react_1.default.createElement(ProductChangeLog_1.default, null)))));
}
exports.default = ProductsView;
